import type { FC } from 'react'

import { Skeleton } from '@/components/ui/skeleton.tsx'

export interface Props {}

export const AudioSkeleton: FC<Props> = () => {
  return <Skeleton className="h-[60px] w-8/12 rounded" />
}
